import { c as _c } from "react/compiler-runtime";
import { getDocumentUploadVaultKeys, isVaultDataDecrypted } from '@onefootprint/core';
import type { DataIdentifier, Document, Entity } from '@onefootprint/request-types/dashboard';
import useEntityVault from '@/entities/hooks/use-entity-vault';
import useAutoDecryptControls from '@/entity/hooks/use-auto-decrypt-controls';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
export const useDocumentField = t0 => {
  const $ = _c(15);
  const {
    entity,
    seqno
  } = t0;
  let t1;
  if ($[0] !== entity.data || $[1] !== entity.id || $[2] !== seqno) {
    t1 = {
      entityAttributes: entity.data,
      entityId: entity.id,
      seqno
    };
    $[0] = entity.data;
    $[1] = entity.id;
    $[2] = seqno;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const vault = useEntityVault(t1);
  const decryptControls = useDecryptControls();
  const autoDecryptControls = useAutoDecryptControls(entity.kind);
  let t2;
  if ($[4] !== vault) {
    t2 = document => {
      if (!vault.data) {
        throw new Error("Vault not loaded");
      }
      const {
        uploads,
        completedVersion,
        kind,
        sambaActivityHistoryCompletedVersion,
        redactedAt
      } = document;
      const imageDis = redactedAt ? [] : uploads.map(_temp);
      if (!completedVersion) {
        return [...new Set([...imageDis])];
      }
      const documentDataKinds = Object.keys(vault.data.dataKinds).filter(key => key.startsWith(`document.${kind}`));
      const textDis = documentDataKinds.map(di => {
        const isSambaActivityDI = di.includes("samba_activity_history_response");
        const useSambaVersion = isSambaActivityDI && sambaActivityHistoryCompletedVersion;
        const version = useSambaVersion ? sambaActivityHistoryCompletedVersion : completedVersion;
        return `${di}:${version}` as DataIdentifier;
      });
      return [...new Set([...imageDis, ...textDis])];
    };
    $[4] = vault;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getRelatedDisByFormValue = t2;
  let t3;
  if ($[6] !== autoDecryptControls || $[7] !== decryptControls || $[8] !== entity.id || $[9] !== getRelatedDisByFormValue || $[10] !== vault) {
    t3 = document_0 => {
      if (!vault.data) {
        throw new Error("Vault not loaded");
      }
      const vaultData = vault.data.vault;
      const isDecryptable = document_0.canDecrypt;
      const isDecrypted = document_0.redactedAt ? getRelatedDisByFormValue(document_0).some(di_0 => isVaultDataDecrypted(vaultData[di_0])) : document_0.uploads.every(upload_0 => getDocumentUploadVaultKeys(document_0, upload_0).some(di_1 => isVaultDataDecrypted(vaultData[di_1])));
      return {
        isDecrypting: autoDecryptControls.isEntityAutoDecrypting(entity.id) || decryptControls.isDecrypting,
        isDecryptable,
        isDecrypted,
        canSelect: isDecryptable && !isDecrypted,
        showCheckbox: decryptControls.step === "selecting-fields" || decryptControls.step === "selecting-reason",
        disabled: !isDecryptable || isDecrypted
      };
    };
    $[6] = autoDecryptControls;
    $[7] = decryptControls;
    $[8] = entity.id;
    $[9] = getRelatedDisByFormValue;
    $[10] = vault;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const getProps = t3;
  let t4;
  if ($[12] !== getProps || $[13] !== getRelatedDisByFormValue) {
    t4 = {
      getProps,
      getRelatedDisByFormValue
    };
    $[12] = getProps;
    $[13] = getRelatedDisByFormValue;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default useDocumentField;
function _temp(upload) {
  return `${upload.identifier}:${upload.version}` as DataIdentifier;
}